import React from 'react';
import PropTypes from 'prop-types';
import rehypeReact from 'rehype-react';

import { mapIcon } from '../../utils/mappers';

import ImageDisplay from '../imageDisplay';
import Cta from '../cta';

const FourColumnSpotlight = ({ groupingTitle, icons = [], iconHeight = 48, cta }) => {
	const renderDescAst = new rehypeReact({
		createElement: React.createElement,
		components: {
			p: ({ children }) => (
				<p className="typography typography--body">{children}</p>
			),
		},
	}).Compiler;
	return (
		<div className={`fc-spotlight ${cta ? '' : 'fc-spotlight--no-cta'}`}>
			<h2 className="typography typography--h2 typography--secondary fc-spotlight__title">
				{groupingTitle}
			</h2>
			<div className="fc-spotlight___items">
				{icons?.map(mapIcon).map(({ title, icon, description }) => (
					<div className="fc-spotlight__items-item" key={title}>
						<figure
							className="fc-spotlight__items-item-icon"
							style={{ height: iconHeight }}
						>
							<ImageDisplay
								alt={icon.alt}
								image={icon.data}
								src={icon.src}
							/>
						</figure>
						<h3 className="typography typography--h3">{title}</h3>
						<div className="fc-spotlight__items-item-subtitle">
							{renderDescAst(description)}
						</div>
					</div>
				))}
			</div>
			<Cta {...cta} customClass="btn btn--outlined" />
		</div>
	);
};

FourColumnSpotlight.propTypes = {
	groupingTitle: PropTypes.string.isRequired,
	icons: PropTypes.arrayOf(
		PropTypes.shape({
			icon: PropTypes.shape({
				gatsbyImageData: PropTypes.object,
				file: PropTypes.shape({ url: PropTypes.string }),
				description: PropTypes.string,
			}),
			title: PropTypes.string.isRequired,
			description: PropTypes.shape({
				childMarkdownRemark: PropTypes.shape({ html: PropTypes.object }),
			}),
		})
	).isRequired,
	iconHeight: PropTypes.number,
	cta: PropTypes.shape({
		link: PropTypes.string,
		title: PropTypes.string,
	}),
};

export default FourColumnSpotlight;
